import { createStore } from "vuex";
import landing from "./domains/landing/store";
import auth from "./domains/authentication/store";
import loader from "./common/store/loader";
import locale from "./common/store/locale";
import currency from "./common/store/currency";
import Navigator from "./common/store";
import Search from "./common/layouts/store/header_search";
import sell from "./domains/sell/store";
import productDetails from "./domains/product-details/store";
import tNotification from "./common/store/t-notification";
import chat from "./domains/product-details/chatStore";
import rfpChat from "./domains/rfp/chatStore";
import filter from "./domains/filter/store";
import aboutUs from "./domains/aboutUs/store";
import faq from "./domains/FAQ/store";
import contactUS from "./domains/contactUs/store";
import rfp from "./domains/rfp/store";
import general from "./common/store/general";
import userDashboardRfp from "./domains/userdashboard/store/rfp"
import checkout from "./domains/checkout/store"
import customer from "./domains/userdashboard/store/customer"
import listing from "./domains/userdashboard/store/listing"
import order from "./domains/userdashboard/store/order"
import watchlist from "./domains/userdashboard/store/watchlist"
import meta from "./domains/meta/store";
import boutique from "./domains/boutique/store";
 import userDashboard from "./domains/userdashboard/store"
export default createStore({
    modules: {
        meta,
        loader,
        faq,
        locale,
        currency,
        landing,
        tNotification,
        auth,
        sell,
        Navigator,
        Search,
        productDetails,
        chat,
        aboutUs,
        filter,
        contactUS,
        rfp,
        general,
        userDashboardRfp,
        checkout,
        customer,
        listing,
        order,
        userDashboard,
        watchlist,
        rfpChat,
        boutique
    },
});